import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import {
  FaBuilding,
  FaFileAlt,
  FaMapMarkedAlt,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaPaperPlane,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaGlobe,
  FaHandHoldingHeart,
  FaUniversity,
  FaUser,
  FaCreditCard,
  FaCode,
  FaShieldAlt,
} from 'react-icons/fa';
import './ContactUs.css';
import Footer from '../footer/Footer';

const offices = [
  {
    title: 'Head Office',
    Icon: FaBuilding,
    lines: [
      'Human Development Society of India (HDSI)',
      '642, Dhotarkheda, Chikhaldara Road,',
      'Block Achalpur, District Amravati,',
      'Maharashtra – 444806, India',
    ],
    phone: '+91 94221 52138 / +91 87670 02290',
  },
  {
    title: 'Registered Office',
    Icon: FaFileAlt,
    lines: [
      'Human Development Society of India (HDSI)',
      'C/o Suresh J. Makasare,',
      'Christian Colony, Near BSNL Office,',
      'Behind Spandan Hospital, Chandrapur,',
      'Maharashtra – 442402, India',
    ],
    phone: '+91 94221 52138 / +91 88068 11004',
  },
  {
    title: 'Administrative & Program Office',
    Icon: FaMapMarkedAlt,
    lines: [
      'HDSI Campus',
      'Devgaon Road, Dhamangaon Gadhi,',
      'Taluka Achalpur, District Amravati,',
      'Maharashtra – 444717, India',
    ],
    phone: '+91 77560 35023 / +91 94221 52138',
  },
  {
    title: 'Regional Office (Pune)',
    Icon: FaMapMarkerAlt,
    lines: [
      'Human Development Society of India (HDSI)',
      'Misty Moors, Kondhwa–Undri,',
      'Pune, Maharashtra – 411060, India',
    ],
    phone: '+91 72192 92525 / +91 87670 02290',
  },
];

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Form submitted');
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero-section">
        <Container>
          <Row className="align-items-center g-5">
            <Col md={6}>
              <span className="contact-eyebrow">— GET IN TOUCH</span>
              <h1>
                We'd Love to
                <br />
                <span className="highlight">Hear From You</span>
              </h1>
              <p>
                Have questions, ideas, or want to collaborate? Reach out to us —
                together we can create stronger communities.
              </p>
            </Col>

            <Col md={6}>
              <div className="contact-hero-media">
                <img
                  src={require('../../Assest/HomeBack/hero-banner.png')}
                  alt="HDSI office"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Offices Section */}
      <section className="contact-offices-section">
        <Container>
          <div className="contact-section-heading">
            <h2>Our Offices</h2>
          </div>

          <Row className="g-4">
            {offices.map((office) => (
              <Col md={6} lg={3} key={office.title} className="d-flex">
                <div className="contact-office-card h-100 w-100">
                  <span className="contact-office-icon">
                    <office.Icon size={22} color="#ffffff" />
                  </span>
                  <h5>{office.title}</h5>
                  <p>
                    {office.lines.map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                  <hr />
                  <p className="contact-office-phone">
                    <FaPhoneAlt size={13} color="#132B4D" className="me-2" />
                    {office.phone}
                  </p>
                  <p className="contact-office-email">
                    <FaEnvelope size={13} color="#132B4D" className="me-2" />
                    hdsi08@gmail.com
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Send Us a Message Section */}
      <section className="contact-form-section">
        <Container>
          <Row className="g-4">
            <Col lg={7} className="d-flex">
              <div className="contact-form-card h-100 w-100">
                <h4>Send Us a Message</h4>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="formName" className="mb-3">
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Your Name *"
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group controlId="formEmail" className="mb-3">
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Your Email *"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group controlId="formPhone" className="mb-3">
                    <Form.Control
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Phone Number *"
                      required
                    />
                  </Form.Group>

                  <Form.Group controlId="formSubject" className="mb-3">
                    <Form.Control
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="Subject *"
                      required
                    />
                  </Form.Group>

                  <Form.Group controlId="formMessage" className="mb-3">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Your Message *"
                      required
                    />
                  </Form.Group>

                  <Button variant="danger" type="submit" className="contact-submit-btn">
                    Send Message <FaPaperPlane className="ms-2" size={14} />
                  </Button>
                </Form>
              </div>
            </Col>

            <Col lg={5} className="d-flex">
              <div className="contact-reach-card h-100 w-100">
                <h4>Other Ways to Reach Us</h4>

                <div className="contact-reach-item">
                  <span className="contact-reach-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FaPhoneAlt style={{ width: '16px', height: '16px', display: 'block' }} color="#ffffff" />
                  </span>
                  <div>
                    <strong>Call Us</strong>
                    <span>+91 94221 52138</span>
                  </div>
                </div>

                <div className="contact-reach-item">
                  <span className="contact-reach-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FaEnvelope size={16} color="#ffffff" />
                  </span>
                  <div>
                    <strong>Email Us</strong>
                    <span>hdsi08@gmail.com</span>
                  </div>
                </div>

                <div className="contact-reach-item">
                  <span className="contact-reach-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FaGlobe style={{ width: '16px', height: '16px', display: 'block' }} color="#ffffff" />
                  </span>
                  <div>
                    <strong>Website</strong>
                    <span>www.hdsi.co.in</span>
                  </div>
                </div>

                <div className="contact-reach-item">
                  <span className="contact-reach-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FaFacebookF style={{ width: '16px', height: '16px', display: 'block' }} color="#ffffff" />
                  </span>
                  <div>
                    <strong>Follow Us</strong>
                    <div className="contact-social-row">
                      <button type="button" className="contact-social-btn" aria-label="Facebook">
                        <FaFacebookF size={14} color="#ffffff" />
                      </button>

                       <a href="https://www.instagram.com/hdsi_official?igsh=MXRseWxiemw2cHowOA=="
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                      >
                        <FaInstagram size={14} color="#ffffff" />
                      </a>
                      <button type="button" className="contact-social-btn" aria-label="YouTube">
                        <FaYoutube size={14} color="#ffffff" />
                      </button>

                       <a href="https://www.linkedin.com/company/human-development-society-of-india/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                      >
                        <FaLinkedinIn size={14} color="#ffffff" />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="contact-map-wrap">
                  <iframe
                    title="HDSI Head Office Location"
                    src="https://www.google.com/maps?q=Dhotarkheda,Chikhaldara+Road,Achalpur,Amravati,Maharashtra&output=embed"
                    width="100%"
                    height="220"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Support Our Mission / Donation Section */}
      <section className="contact-donate-section">
        <Container>
          <div className="contact-section-heading">
            <span className="contact-eyebrow contact-eyebrow--light">— SUPPORT OUR MISSION —</span>
            <h2>Your Contribution Creates Real Change</h2>
            <p className="contact-donate-subtext">
              Your support helps us build a better future for communities
              and create lasting impact where it matters most.
            </p>
          </div>

          <Row className="g-4 align-items-stretch">
            <Col lg={5} className="d-flex">
              <div className="contact-donate-card h-100 w-100">
                <span className="contact-donate-icon">
                  <FaHandHoldingHeart size={30} color="#D62839" />
                </span>
                <h3>Support Our Mission</h3>
                <p>
                  Every contribution helps us provide education, clean water,
                  healthcare, and sustainable livelihoods to those who need it
                  the most. Thank you for being a part of the change.
                </p>
                <Link to="/donate" className="contact-donate-btn">
                  <FaHandHoldingHeart className="me-2" />
                  Donate Now
                </Link>
              </div>
            </Col>

            <Col lg={7} className="d-flex">
              <div className="contact-bank-card h-100 w-100">
                <h5>Bank Transfer Details</h5>
                <ul className="contact-bank-list">
                  <li>
                    <span className="contact-bank-icon"><FaUniversity size={16} /></span>
                    <span className="contact-bank-label">Bank Name</span>
                    <strong>Bank of India</strong>
                  </li>
                  <li>
                    <span className="contact-bank-icon"><FaUser size={16} /></span>
                    <span className="contact-bank-label">Account Name</span>
                    <strong>Human Development Society of India</strong>
                  </li>
                  <li>
                    <span className="contact-bank-icon"><FaCreditCard size={16} /></span>
                    <span className="contact-bank-label">Account No.</span>
                    <strong>96822 01100 00207</strong>
                  </li>
                  <li>
                    <span className="contact-bank-icon"><FaCode size={16} /></span>
                    <span className="contact-bank-label">IFSC Code</span>
                    <strong>BKID0009682</strong>
                  </li>
                  <li>
                    <span className="contact-bank-icon"><FaMapMarkerAlt size={16} /></span>
                    <span className="contact-bank-label">Branch</span>
                    <strong>Achalpur, Dist. Amravati, Maharashtra</strong>
                  </li>
                </ul>

                <div className="contact-bank-note">
                  <span className="contact-bank-note-icon">
                    <FaShieldAlt size={16} />
                  </span>
                  <p>
                    All donations to HDSI are eligible for 80G tax exemption
                    under the Income Tax Act.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default ContactUs;